import bookingsStore from './bookings'
import categoriesStore from './categories'
import eventsStore from './events'

export default {
  modules: {
    bookings: {
      namespaced: true,
      ...bookingsStore
    },
    categories: {
      namespaced: true,
      ...categoriesStore
    },
    events: {
      namespaced: true,
      ...eventsStore
    }
  }
}
